<div class="c-modal c-modal--sm" id="modal-{{vm.uid}}">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p style="font-size: 22px">
						{{ 'Employees.Placeholder.UpdateAdditionalInfoTitle' | translate }} {{ vm.isSecond ? "2" : ""}}
					</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close"
							(click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<form name="vm.form" #mainForm="ngForm" class="c-form u-ost-md">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p u-osb-sm">
							{{ 'Employees.Name' | translate }}: {{vm.getName()}}
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
							<div class="c-form__group u-osb-lg">
								<label class="c-form__label c-form__label">
								    {{ 'Employees.Placeholder.AdditionalInfoShort' | translate }} {{ vm.isSecond ? "2" : ""}}
								</label>
								<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': vm.submitted && additionalInfo.invalid }">
									<textarea rows="4" type="text" id="{{ 'additionalInfo-' + vm.uid }}" name="additionalInfo" class="c-form__input c-form__input--sm" #additionalInfo="ngModel" [(ngModel)]="vm.additionalInfo" maxlength="255"></textarea>
								</div>
							</div>
						</div>
					</div>
					<div class="c-panel u-no-p u-ost-sm u-osb-sm">
						<button type="button"
	                            id="updateAdditionalInfoButton"
								(click)="vm.submit(mainForm)"
								[disabled]="vm.processing || !vm.initialized"
								class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
							{{ 'Modal.Button.Update' | translate }}
						</button>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
